import axios from 'axios';
import qs from 'qs';

import Logger from '@/Logger';

// Create instance of logger
const logger = new Logger('navigationStore', 'Actions');

export default {
  getNavigation({ commit, dispatch }) {
    return new Promise(async (resolve, reject) => {
      try {
        // Capture the response data for menu and website.
        const response = await axios.get('menu');

        // Log action and status.
        logger.info('getNavigation', 'Response', response.data);

        // Commit response data to navigation store
        commit('setMenuContent', response.data.menu);

        await dispatch('getActiveWebsite');

        // Resolve promise
        resolve();

      // Catch error
      } catch (error) {
        // Log action and status.
        logger.warn('getNavigation', 'Response', {
          [error.response.status]: error.response.statusText,
        });

        // Reject promise
        reject();
      }
    });
  },
  getActiveWebsite({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.get('website');
        // Log action and status.
        logger.info('getActiveWebsite', 'Response', response.data);

        commit('setActiveWebsite', response.data.website);

        // Resolve promise
        resolve();

      // Catch error
      } catch (error) {
        // Log action and status.
        logger.warn('getActiveWebsite', 'Response', {
          [error.response.status]: error.response.statusText,
        });

        // Reject promise
        reject();
      }
    });
  },
  async changeWebsite({ dispatch }, website) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post('website', qs.stringify({ active: website.id }));

        // Log action and status.
        logger.info('changeWebsite', 'Response', response.data);

        // Set new active website on response success.
        await dispatch('getNavigation');

        // Finally, update the user store so that active website change is reflected.
        await dispatch('getMe');

        // Resolve promise
        resolve();

      // Catch error
      } catch (error) {
        // Log action and status.
        logger.warn('changeWebsite', 'Response', {
          [error.response.status]: error.response.statusText,
        });

        // Reject promise
        reject();
      }
    });
  },
};
